import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { KmxContainer } from '../../../components/KmxContainer';
import useAppState from '../../../common/state/appState';

const QuickLinks = [
    {
        label: 'Sell/Trade',
        href: '/sell-my-car?op=homepage_hero',
    },
    {
        label: 'Finance',
        href: '/car-financing',
    },
    {
        label: 'Research',
        href: '/research',
    },
];

const MobileQuickLinks = () => {
    const serveUFTContentEnabled = useAppState((state) => state.serveUFTContent);

    return (
        <KmxContainer
            maxWidth={serveUFTContentEnabled ? 'xl' : 'md'}
            sx={{ display: { xs: 'block', sm: 'none' }, px: { xs: 1.5 } }}
        >
            <Grid container spacing={0.5}>
                {QuickLinks.map(({ label, href }) => (
                    <Grid key={label} size={4}>
                        <Button
                            fullWidth
                            variant="outlined"
                            color="secondary"
                            size="small"
                            href={href}
                            sx={{ border: '1px solid #ccd0d6' }}
                        >
                            {label}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </KmxContainer>
    );
};

export default MobileQuickLinks;
